import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ButtonComponent } from '../../button/button.component';
import { ButtonCrossComponent } from '../../buttons/button-cross/button-cross.component';
import { ModalBaseComponent } from '../modal.base';

@Component({
  selector: 'app-await.modal',
  standalone: true,
  imports: [CommonModule, ButtonComponent, ButtonCrossComponent],
  templateUrl: './await.modal.component.html',
  styleUrls: ['./await.modal.component.scss', '../modal.styles.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AwaitModalComponent extends ModalBaseComponent {}
